import { useEffect, useState } from 'react';
import { THUMB_WIDTH } from '../constants';
import { renderPageThumb } from '../engine/pdfEngine';

/**
 * Thumbnail cache keyed by the pdf.js document, so duplicated pages reuse one
 * raster and re-opening a file does not re-render what is already drawn.
 */
const cache = new WeakMap();

export function useThumbnails(pdf, sourceIndices) {
    const [thumbs, setThumbs] = useState({});

    useEffect(() => {
        if (!pdf) return undefined;
        if (!cache.has(pdf)) cache.set(pdf, new Map());
        const store = cache.get(pdf);
        let cancelled = false;

        setThumbs(Object.fromEntries(store));

        (async () => {
            for (const index of sourceIndices) {
                if (cancelled) return;
                if (index == null || store.has(index)) continue;
                try {
                    // eslint-disable-next-line no-await-in-loop
                    const src = await renderPageThumb(pdf, index + 1, THUMB_WIDTH);
                    if (cancelled) return;
                    store.set(index, src);
                    setThumbs(Object.fromEntries(store));
                } catch { /* keep going — one bad page must not stop the strip */ }
            }
        })();

        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pdf, sourceIndices.join(',')]);

    return thumbs;
}
